import { render, staticRenderFns } from "./SemesterDetail.vue?vue&type=template&id=f44d176a"
import script from "./SemesterDetail.vue?vue&type=script&lang=js"
export * from "./SemesterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports